import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import warningEmojiUrl from '@/assets/apple-emoji/warning.png?url';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ErrorContainer = styled.div<{ $variant?: 'light' | 'dark' }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  animation: ${slideIn} 0.3s ease-out;

  ${({ $variant }) =>
    $variant === 'dark'
      ? `
        background: rgba(127, 29, 29, 0.4);
        border: 1px solid rgba(248, 113, 113, 0.5);
        color: #fca5a5;
      `
      : `
        background: #fef2f2;
        border: 1px solid #fecaca;
        color: #dc2626;
      `}
`;

const ErrorIcon = styled.img`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 0;
  object-fit: contain;
`;

const ErrorMessage = styled.div`
  flex: 1;
  word-wrap: break-word;
`;

interface PaymentErrorProps {
  error?: string;
  /** Стиль для светлого (default) или тёмного фона (v4, v5) */
  variant?: 'light' | 'dark';
}

export function PaymentError({ error, variant = 'light' }: PaymentErrorProps) {
  if (!error) return null;

  return (
    <ErrorContainer $variant={variant}>
      <ErrorIcon src={warningEmojiUrl} alt="" aria-hidden="true" />
      <ErrorMessage>{error}</ErrorMessage>
    </ErrorContainer>
  );
}
